import React, { Component } from 'react';
import HttpRunner from '../query';
import urlHandler from '../../../utils/urlHandler';
import perms from '../../../utils/permissions';
import examples from '../../../utils/examples';
import miscUtils from '../../../utils/miscUtils';

class DocPhoneEntity extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH)
        }) 
    }

    render() {
        return (
            <div className="bucket" id="top">
                <div>
                    <h3 className="heading-1" id='phone'>Phone</h3>
                    <div className="description">
                        Telephone numbers are governed by a specification known as a numbering plan. Numbering plans define the
                        length and range of allowable numbers as well as the allocation and geographic distribution of those numbers.
                        The displayed format (grouping, separators, keywords) of phone numbers may be defined by the numbering plan
                        or it may be defined by a separate formatting document. Most countries public phone numbers adhere to ITU-T E.164
                        and ITU-T E.123 which are broadly defined international telephone numbering plan and format specifications.
                        The international standards allow individual countries to create their own numbering plans which are more
                        detailed and specific to a country as long as they adhere to the more general international specifications.
                    </div>

                    <h5 className="heading-3">International Numbers</h5>
                    <div className="description">
                        The international standards also specify a common format to use when providing a number for use outside of the
                        number&quot;s originating country, but allow each country to specify their own internal format, with some limitations.
                        This inter-country format is officially known as an International Public Telephone Number Format, or more commonly, an
                        International Number. The intra-country format is officially known as a National Phone Number Format, or more commonly, a National Number.
                    </div>

                    <h5 className="heading-3">North American Numbers</h5>
                    <div className="description">
                        The extraction of North American phone numbers is based on the {miscUtils.createExternalLink('https://en.wikipedia.org/wiki/North_American_Numbering_Plan','North American Numbering Plan')} (NANP).
                        A NANP number is written as separated number groups, each with a specific semantic purpose. The Station Code
                        (also Subscriber Number) identifies an individual subscriber at a local level.
                    </div>

                    <h5 className="heading-3">Exchange Code</h5>
                    <div className="description">
                        The Exchange Code (also Central Office Code or Prefix) identifies a local exchange that is responsible for individual subscribers.
                    </div>

                    <h5 className="heading-3">Area Codes</h5>
                    <div className="descriptionode">
                        The Area Code (also Numbering Plan Area Code or NPA) identifies a regional exchange that is responsible for several
                        local exchanges. The National Trunk Prefix (also Trunk Prefix, Long Distance Dialing Code, or Dialing Code) is used
                        to dial inter Area Code (i.e. long distance) numbers.
                    </div>

                    <h5 className="heading-3">Extraction Patterns</h5>
                    <div className="description">
                        The NANP extraction pattern will extract well-formed numbers, common variations of well-formed numbers (including
                        shorthand/abbreviated area/exchange codes), subscriber extensions, and some malformed numbers. It will identify
                        the parts of a number (area code, exchange code, etc...), provide some detailed contextual information about numbers,
                        and flag numbers in known categories (i.e. A future expansion or invalid area code).
                    </div>

                    <h5 className="heading-4">Examples</h5>
                    <div className="description">
                        If the NANP number is written in an international format, the International
                        Prefix Code and International Country Code will also be extracted.
                    </div>

                    <div className="example-content">
                        <div className="line">Full number with international prefix code and international country code (i.e. +1-513-555-0100)</div>
                        <div className="line">National format and standard variations</div>
                        <div className="line">Full number with national prefix code and/or area code (i.e. 1-513-555-0100) </div>
                        <div className="line">Full number minus national prefix code and/or area code (i.e. 513-555-0100) </div>
                        <div className="line">No area code (i.e. 555-0100) </div>
                        <div className="line">Parenthesis around area code ( i.e. 1-(513)-555-0100, (513)-555-0100 ) </div>
                        <div className="line">Extensions of various formats (i.e. 555-0100 ext=1234, 555-0100x1234, 555-0100;1234, etc...) </div>
                    </div>

                    <h4 className="heading-2">Shorthand/Abbreviated numbers</h4>

                    <h5 className="heading-3">Area codes</h5>
                    <div className="description">Used for local dialing in metro areas with overlay area codes.</div>
                    <div className="example-content">
                        <div className="line">4)555-0100 abbreviates 404-555- 0100</div>
                    </div>
                    <br/>
                    <h5 className="heading-3">Exchange codes</h5>
                    <div className="description">Used for local dialing of military DSN numbers, PBX exchanges, and some rural areas utilizing a single exchange.</div>
                    <div className="example-content">
                        <div className="line"> 7/4501 abbreviates 847-4501</div>
                    </div>
                </div>

                <div>
                    <h4 className="heading-2" id="normalizedPhone">Normalized Form</h4>
                    <div className="description">
                        The normalized form of a NANP phone number will vary depending upon the information
                        available. The full normalized international form is, "+1-AAA-EEE-SSSS ext=XXXX". The full normalized national form is,
                        "1-AAA-EEE-SSSS ext=XXXX". However, omitted portions of the number (i.e. area code) will prevent the full normalized form
                        from being generated. Also, variations to the number (i.e. shorthand area code) may alter the normalization. Generally, the
                        number is normalized by displaying all available portions of the number and using dashes for number group separators and a
                        space between the extension. Normalization of shorthand area codes are the exception and use the right parenthesis for a
                        separator since that is the most common representation.
                    </div>

                    <h5 className="heading-3">Full international number</h5>
                    <div className="example-content">
                        <div className="line">+C-AAA-EEE-SSSS ext=XXXXX</div>
                    </div>

                    <h5 className="heading-3">Full national number </h5>
                    <div className="example-content">
                        <div>N-AAA-EEE-SSSS ext=XXXXX</div>
                    </div>

                    <h5 className="heading-3">Number minus long distance dialing code </h5>
                    <div className="example-content">
                        <div className="line">AAA-EEE-SSSS ext=XXXXX </div>
                    </div>

                    <h5 className="heading-3">Number minus dialing code and area code</h5>
                    <div className="example-content">
                        <div>EEE-SSSS ext=XXXXX </div>
                    </div>

                    <h5 className="heading-3">Shorthand/abbreviated area code</h5>
                    <div className="example-content">
                        <div>EEE-SSSS ext=XXXXX </div>
                    </div>

                    <h5 className="heading-3">Shorthand/abbreviated exchange code </h5>
                    <div className="example-content">
                        <div className="line">E-SSSS ext=XXXXX </div>
                        <div className="line">C = International Country Code </div>
                        <div className="line">N = National Trunk Prefix Code </div>
                        <div className="line">AAA = Area Code </div>
                        <div className="line">EEE = Exchange Code (Prefix) </div>
                        <div className="line">SSSS = Station Code (Subscriber Number) </div>
                        <div className="line">A = Shorthand/Abbreviated Area Code </div>
                        <div className="line">E = Shorthand/Abbreviated Exchange Code </div>
                        <div className="line">ext is used for internal extensions and is optional </div>
                        <div className="line">XXXX = Extension number (1 to 5 digits)</div>
                    </div>
                    <br/>
                    <div className="description">
                        An extracted North American Phone Number may be represented by the following
                        attributes:
                    </div>

                    <table className="table-wrapper">
                        <thead className="table-header">
                        <tr>
                            <th>Attribute </th>
                            <th>Meaning </th>
                            <th>Type </th>
                            <th>Constraints</th>
                            <th>Notes </th>
                        </tr>
                        </thead>
                        <tbody className="table-body">
                        <tr>
                            <td className="attribute">trunkPrefix</td>
                            <td className="meaning">Prefix used to dial out of a country when making international calls</td>
                            <td className="type">String</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">Always "011" for North American Numbers</td>
                        </tr>
                        <tr>
                            <td className="attribute">countryCode</td>
                            <td className="meaning">Prefix used to dial into a specific country</td>
                            <td className="type">String</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">Always "1" for North American Numbers</td>
                        </tr>
                        <tr>
                            <td className="attribute">nationalTrunkPrefix</td>
                            <td className="meaning">Prefix used when dialing from one area code to another</td>
                            <td className="type">String</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">Always "1" for North American Numbers</td>
                        </tr>
                        <tr>
                            <td className="attribute">areaCode</td>
                            <td className="meaning">3-digit number assigned to a particular geographic area</td>
                            <td className="type">String</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">May (rarely) be represented as a 1-digit number</td>
                        </tr>
                        <tr>
                            <td className="attribute">exchangeCode</td>
                            <td className="meaning">3-digit number assigned to a particular exchange within an area code</td>
                            <td className="type">String</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">Limited to numbers in the United States</td>
                        </tr>
                        <tr>
                            <td className="attribute">stationCode</td>
                            <td className="meaning">4-digit number assigned to a particular subscriber</td>
                            <td className="type">String</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">Limited to numbers in the United States</td>
                        </tr>
                        <tr>
                            <td className="attribute">extensionNumber</td>
                            <td className="meaning">Used to access a phone on an internal PBX</td>
                            <td className="type">String</td>
                            <td className="constraints">Optional</td>
                            <td className="notes"></td>
                        </tr>
                        <tr>
                            <td className="attribute">areaCodeType</td>
                            <td className="meaning">Contains text describing the nature/purpose of an area code </td>
                            <td className="type">String</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">

                                <p><em>Possible Values:</em></p>
                                <p>"Shorthand Area Code" - i.e. "4)555-0100"</p>
                                <p>"Expansion Area Code" - Area codes reserved for future expansion</p>
                                <p>"Contiguous Use Area Code" - Area codes reserved for future use requiring contiguous numbering </p>
                                <p>"Invalid Area Code" - Area codes that are correctly formatted, but that are not in a valid numeric range </p>
                                <p>"Easily Recognizable Code" - Area codes with identical second and third digits (i.e. 800, 888, 900) </p>
                                <p>"Personal Communication Code (In Use)" - Numbers set aside for personal communication services </p>
                                <p>"Carrier Service Code" - Used for carrier specific services </p>
                            </td>
                        </tr>
                        <tr>
                            <td className="attribute">exchangeCodeType</td>
                            <td className="meaning">Contains text describing the nature/purpose of an exchange code</td>
                            <td className="type">String</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">
                                <p><em>Possible Values:</em></p>
                                <p>"Shorthand Exchange Code" - i.e. 7-4123 is an abbreviation for 847-4123 </p>
                                <p>"Invalid Exchange Code" - Area codes that are correctly formatted, but that are not in a valid numeric range </p>
                                <p>"Carrier Service Code" - The exchange code portion of a carrier service code </p>
                            </td>
                        </tr>
                        <tr>
                            <td className="attribute">numberType</td>
                            <td className="meaning">Contains text describing the entire phone number</td>
                            <td className="type">String</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">
                                <p><em>Possible Values</em></p>
                                <p>"Public Switched Network ServicesDirectory Assistance (Toll Free)" - Provide services for hearing impaired, speech impaired, etc...</p>
                                <p>"Directory Assistance (Locality)"</p>
                                <p>"Fictional Use Number" - Numbers set aside for fictional use in media</p>
                                <p>"Information Services Number" - Set aside for information services numbers (i.e. 555- TAXI)</p>
                            </td>
                        </tr>
                        <tr>
                            <td className="attribute">nationalSignificantNumber</td>
                            <td className="meaning">Sequence of numbers describing the National Destination Code and Subscriber Number</td>
                            <td className="type">String</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">This sequence is specific to the country code</td>
                        </tr>
                        </tbody>
                    </table>

                    <h4 className="heading-2">Example</h4>
                    <div className="example-content">Toll Free Number: ...Toll Free: 800/659-0059 Kathleen A. Sauvé - Media Relations...</div>
                    <HttpRunner example="phone1" 
                        query="enrich"
                        response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_PHONE1) : null}/>

                    <h4 className="heading-2">Non-Standard Extention Example</h4>
                    <div className="example-content"> ...contact Gary Laurence (XFD) at ext. 2-9670...</div>
                    <HttpRunner example="phone2" 
                        query="enrich"
                        response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_PHONE2) : null}/>
                </div>
            </div>
        );
    }
}

export default DocPhoneEntity;